<template>
  <div style="height: 100%">
    <v-card style="height: 100%" class=""
            :class="$vuetify.breakpoint.mdAndUp ? 'desktop_inbox_card ml-4' : 'desktop_card'">
      <v-card-title class="justify-space-between">
        <label class="--v-primary-base text-left" :class="$vuetify.breakpoint.mdAndUp ? 'ml-4 inbox-desktop-txt' : ''">{{ $t(`label.exclusiveInboxBonus`)
          }}</label>
      </v-card-title>
      <v-row no-gutters align="end" class="hidden-sm-and-down pt-6 pb-3 voucher-border">
        <v-col>
          <v-divider></v-divider>
        </v-col>
      </v-row>
      <v-card class="inbox-card profile-detail-card" :class="$vuetify.breakpoint.mdAndDown ? 'profile-detail-card' : ''"
              elevation="0">
        <v-row no-gutters align="start" justify="start" class="pa-4"
               :class="$vuetify.breakpoint.mdAndDown ? 'px-2' : 'pt-1'">
          <v-col cols="12" v-for="(a, index) in selectedList" :key="a.id" @click="openMsgDialog(a.id)"
                 :class="a.has_read ? 'inbox-message-isread' : ''">
            <!--mobile view inbox-->
            <v-row v-if="$vuetify.breakpoint.mdAndDown" class="py-1 o-gutters">
              <v-col cols="9" md="3" lg="2">
                <v-checkbox v-model="a.selected" class="mt-0 bonus-message-subject" v-bind:label="a.subjects && a.subjects[language] ? a.subjects[language] : a.subject" color="primary"
                            hide-details></v-checkbox>
              </v-col>
              <v-col cols="3" md="3" lg="2" class="d-flex">
                <label class="inbox-message-date">{{ a.send_at | shortDate }}</label>
              </v-col>
            </v-row>
            <!--desktop view inbox-->
            <v-row v-if="$vuetify.breakpoint.lgAndUp" no-gutters class="py-1 inbox-content">
              <v-col cols="1">
                <v-checkbox class="mt-0" v-model="a.selected" hide-details></v-checkbox>
              </v-col>
              <v-col cols="8">
                <v-row no-gutters @click="openMsgDialogs(a)">
                  <v-col cols="12" class="mb-3">
                    <label class="font-weight-bold">{{ a.subjects && a.subjects[language] ? a.subjects[language] : a.subject }}</label>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="2" class="text-right pr-4">
                <label class="mt-0 font-weight">{{ a.send_at | shortDate }}</label>
              </v-col>
              <v-col cols="1">
                <label class="mt-0 font-weight">{{ a.send_at | shortTime }}</label>
              </v-col>
            </v-row>
            <v-row v-if="$vuetify.breakpoint.mdAndDown" no-gutters class="py-3">
              <v-col cols="12">
                <v-divider v-if="index !== inboxList.length - 1"></v-divider>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="pt-1 pb-3 text-center" v-if="inboxList.length == 0">
            <label class="field-name">{{ $t(`message.noMeassage`) }}</label>
          </v-col>
          <v-col cols="12" v-if="$vuetify.breakpoint.mdAndDown">
            <v-divider></v-divider>
          </v-col>
        </v-row>
        <v-row no-gutters :class="$vuetify.breakpoint.mdAndDown ? 'mb-6' : ''" v-if="pagination.totalPage > 1">
          <v-col cols="12">
            <v-pagination
                light
                circle
                class="vip_summary_pagination"
                v-model="pagination.currentPage"
                :length="pagination.totalPage"
                @input="changePage"
                :next-icon="'arrow_forward_ios'"
                :prev-icon="'arrow_back_ios'"
                :total-visible="pagination.paginationPageLimit"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card>
    </v-card>
    <bonus-dialog :dialogShow="msgDialog.show" :max-width="600" :title="msgDialog.title" :subtitle="''"
                  :dialogImage="msgDialog.imgUrl" :closeAction="this.closeMsgDialog"
                  :hasPrev="hasPrevMsg" :hasNext="hasNextMsg"
                  :prevAction="prevMsg" :nextAction="nextMsg">
      <div :class="[$vuetify.breakpoint.mdAndDown ? 'px-4' : 'px-12']">
        <div v-html="msgDialog.msg"
             :class="['inbox_msg_content' , $vuetify.breakpoint.smAndDown ? '' : 'px-3']">
        </div>
        <div style="text-align: center; display: flex; justify-content: center; gap: 10px; margin-top: 16px; padding-bottom: 16px; width: 100%;">
          <app-button v-if="msgDialog.moreDetails" class="white--text" :action="() => handleCtaClick(msgDialog.moreDetails)" custom-class="more-details-button" title="More Details"></app-button>
          <app-button :action="() => msgDialog.bonusType ? claimBonus(msgDialog.bonusType, msgDialog.bonusId) : handleCtaClick(msgDialog.ctaButtonLink)" custom-class="claim-now-button-yellow" :title="msgDialog.ctaButtonText || $t(`label.claim`)"></app-button>
        </div>
      </div>
    </bonus-dialog>
    <newapp-dialog :dialogShow="msgDialogs.show" :title="msgDialogs.title" :subtitle="msgDialogs.subtitle"
                   :max-width="1100" :closeAction="this.closeMsgDialogs" custom-class="pa-6">
      <v-container
          :class="[$vuetify.breakpoint.mdAndDown ? 'px-3' : 'px-5', $vuetify.breakpoint.smAndDown ? 'maxFrameHeight' : 'fill-height']">
        <div v-html="formattedMsg(msgDialogs.msg)"
             :class="['inbox_msg_content' , $vuetify.breakpoint.smAndDown ? '' : 'flow-overHeight']"></div>
      </v-container>
      <template v-slot:footer v-if="claimVoucherButtonShow">
        <v-col cols="12" style="text-align: center">
          <app-button class="white--text dialog-button" :action="() => claimBonus(msgDialogs.bonusType, msgDialogs.bonusId)" custom-class="claim-now-button-blue" :title="$t(`label.claimNow`)"></app-button>
        </v-col>
      </template>
    </newapp-dialog>

    <app-dialog :dialogShow="claimVoucherDialogShow" :max-width="600" :title="$t(`label.claimVoucher`)" :closeAction="this.closeClaimVoucherDialog">
      <claim-voucher-dialog :bonus-id="bonusId" @close-dialog="this.claimSuccessCloseDialog"></claim-voucher-dialog>
    </app-dialog>
  </div>
</template>
<script>
import { ROUTE_NAME } from "@/constants/route.constants";
import { uiHelper, locale, errorCodeHelper, formValidator } from "@/util";
import { SHARED } from "@/constants/constants";
import deleteIcon from "@/assets/svg/delete-icon.svg";
import readIcon from "@/assets/svg/read-icon.svg";
import deleteIcon2 from "@/assets/svg/delete-icon-2.svg";

import _ from "lodash";
import {
  INBOX_GET_EXCLUSIVE_BONUS_FT,
  INBOX_GET_MSG,
  INBOX_READ_MSG,
  INBOX_DELETE_MSG,
  INBOX_READ_BULK_MSG,
  INBOX_GET_MSG_CONTENT,
  INBOX_READ_EXCLUSIVE_BONUS_FT
} from "@/store/inbox.module";
import NewappDialog from "@/components/newDialog.vue";
import BonusDialog from "@/components/bonusDialog.vue";
import {InboxMsgBonus} from "@/constants/enums/inbox-msg-bonus.enum";
import AppLogin from "@/components/member/login.vue";
import ClaimVoucherDialog from "@/views/profile/claimVoucherDialog.vue";
import {GET_VOUCHER_CODE_RESET, IS_VOUCHER_CLAIMED, IS_VOUCHER_CLAIMED_RESET, IS_BONUS_CLAIMED, IS_BONUS_CLAIMED_RESET } from "@/store/bonus.module";

export default {
  name: "myInbox",
  components: {
    ClaimVoucherDialog,
    AppLogin,
    NewappDialog,
    BonusDialog,
    deleteIcon,
    deleteIcon2,
    readIcon
  },
  data: () => ({
    language: uiHelper.getLanguage(),
    validator: formValidator,
    shared: SHARED,
    selectedTab: "inbox",
    msgDialog: {
      show: false
    },
    msgDialogs: {
      show: false
    },
    selectAll: false,
    inboxList: [],
    selectedList: [],
    pagination: {
      currentPage: 1,
      totalPage: 1,
      paginationPageLimit: 10
    },
    searchCriteria: {
      pageNumber: 1,
      pageSize: 10,
      mobilePageSize: 10
    },
    claimVoucherDialogShow: false,
    bonusId: 0,
    claimVoucherButtonShow: false,
    currentMsgIndex: -1
  }),
  created() {
    this.getExclusiveBonusFt();
  },
  computed: {
    msgRes() {
      return this.$store.state.inbox.exclusiveBonusFt;
    },
    isVoucherClaimedResult() {
      return this.$store.state.bonus.isVoucherClaimed.complete;
    },
    isBonusClaimedResult() {
      return this.$store.state.bonus.isBonusClaimed.complete;
    },
    allInboxItems() {
      return this.$store.state.inbox.exclusiveBonusFt.list.filter(a => a.event === 'inbox')
    },
    currentInboxIdx() {
      if (!this.msgDialog || !this.msgDialog.id) return -1
      return this.allInboxItems.findIndex(a => a.id == this.msgDialog.id)
    },
    hasPrevMsg() {
      return this.currentInboxIdx > 0
    },
    hasNextMsg() {
      return this.currentInboxIdx < this.allInboxItems.length - 1
    }
  },
  watch: {
    msgRes() {
      this.getFilterInboxList();
      this.onChangeTab(this.selectedTab);
    },
    isVoucherClaimedResult() {
      if (this.$store.state.bonus.isVoucherClaimed.complete) {
        this.claimVoucherButtonShow = !this.$store.state.bonus.isVoucherClaimed.data;
      }
    },
    isBonusClaimedResult() {
      if (this.$store.state.bonus.isBonusClaimed.complete) {
        this.claimVoucherButtonShow = !this.$store.state.bonus.isBonusClaimed.data;
      }
    }
  },
  methods: {
    naviToPromotion() {
      this.$router.push({
        name: ROUTE_NAME.PROMOTION
      })
    },
    handleCtaClick(link) {
      this.closeMsgDialog()
      if (!link) {
        this.$router.push({ name: ROUTE_NAME.PROMOTION })
        return
      }
      if (link.startsWith('http://') || link.startsWith('https://')) {
        window.open(link, '_blank')
      } else {
        this.$router.push(link)
      }
    },
    formattedMsg(msg) {
      if (!msg) return ''
      return msg.replace(/\n/g, '<br>')
    },
    selectAllCheckboxes() {
      this.selectedList.forEach(item => {
        item.selected = this.selectAll;
      });
    },
    getFilterInboxList() {
      let self = this;
      this.inboxList = _.cloneDeep(
          this.$store.state.inbox.exclusiveBonusFt.list.filter(a => {
            self.$options.filters.shortDate(a.sent_at);
            return a.event === 'inbox';
          })
      );
    },
    getExclusiveBonusFt() {
      this.$store.dispatch(`${INBOX_GET_EXCLUSIVE_BONUS_FT}`);
    },
    async getInboxMsgContent(msg) {
      let obj = {
        msgId: msg.id,
        category: msg.category,
        language: uiHelper.getLanguage(),
      };
      await this.$store.dispatch(`${INBOX_GET_MSG_CONTENT}`, { obj });
    },
    readInboxMsg(msgId, categoryId) {
      let obj = {
        msgId: msgId
      };
      this.$store.dispatch(`${INBOX_READ_EXCLUSIVE_BONUS_FT}`, { obj });
      this.getInboxMsg();
    },
    async openMsgDialog(selectedMsg) {
      let inboxContent = this.$store.state.inbox.exclusiveBonusFt.list.find(a => {
        return a.id == selectedMsg;
      })

      if (!inboxContent) return

      this.currentMsgIndex = this.inboxList.findIndex(a => a.id == selectedMsg)

      const pageSize = this.$vuetify.breakpoint.xsOnly ? this.searchCriteria.mobilePageSize : this.searchCriteria.pageSize
      const targetPage = Math.floor(this.currentMsgIndex / pageSize) + 1
      if (targetPage !== this.pagination.currentPage) {
        this.pagination.currentPage = targetPage
        this.changePage(targetPage)
      }

      this.msgDialog = {
        show: true,
        id: inboxContent.id,
        msg: inboxContent.content ? inboxContent.content.replace(/<(?:image|img)\b[^>]*>/gi, '') : null,
        title: inboxContent.subject,
        subtitle: inboxContent.message,
        imgUrl: inboxContent.img_url,
        ctaButtonLink: inboxContent.cta_button_link || null,
        ctaButtonText: inboxContent.cta_button_text || null,
        moreDetails: inboxContent.more_details || null,
        bonusType: inboxContent.bonus_type === 'VOUCHER' ? InboxMsgBonus.VOUCHER
          : inboxContent.bonus_type === 'BONUS' ? InboxMsgBonus.BONUS
          : (parseInt(inboxContent.bonus_type) || 0),
        bonusId: inboxContent.bonus_id || 0,
      };

      const listItem = this.selectedList.find(a => a.id == selectedMsg)
      if (listItem) listItem.has_read = true
      const inboxItem = this.inboxList.find(a => a.id == selectedMsg)
      if (inboxItem) inboxItem.has_read = true

      this.readInboxMsg(inboxContent.id);
    },
    prevMsg() {
      const idx = this.currentInboxIdx
      if (idx > 0) {
        this.openMsgDialog(this.allInboxItems[idx - 1].id)
      }
    },
    nextMsg() {
      const idx = this.currentInboxIdx
      if (idx < this.allInboxItems.length - 1) {
        this.openMsgDialog(this.allInboxItems[idx + 1].id)
      }
    },
    async openMsgDialogs(selectedMsg) {
      await this.getInboxMsgContent(selectedMsg)
      let inboxContent = this.$store.state.inbox.inboxMsgContent
      await this.showVoucherClaim(inboxContent.bonusType, inboxContent.bonusId);

      this.msgDialogs = {
        show: true,
        msg: inboxContent.content,
        title: inboxContent.subject,
        subtitle: inboxContent.message,
        bonusId: inboxContent.bonusId,
        bonusType: inboxContent.bonusType
      };
      this.readInboxMsg(selectedMsg.id, selectedMsg.category);
    },
    closeMsgDialog() {
      this.msgDialog = {
        show: false
      };
    },
    closeMsgDialogs() {
      this.msgDialogs = {
        show: false
      };
    },
    onChangeTab(tab) {
      this.selectedTab = tab;
      if (tab == "inbox") {
        this.renderPage(this.inboxList);
      }
    },
    renderPage(list) {
      if (this.$vuetify.breakpoint.xsOnly) {
        this.pagination.totalPage = Math.ceil(list.length / this.searchCriteria.mobilePageSize);
      } else {
        this.pagination.totalPage = Math.ceil(list.length / this.searchCriteria.pageSize);
      }
      this.searchCriteria.pageNumber = 1;
      this.changePage(1);
    },
    changePage(targetPage) {
      let list = [];
      if (this.selectedTab == "inbox") {
        list = this.inboxList;
      }
      this.searchCriteria.pageNumber = targetPage;
      if (this.$vuetify.breakpoint.xsOnly) {
        this.selectedList = list.slice((this.searchCriteria.pageNumber - 1) * this.searchCriteria.mobilePageSize, this.searchCriteria.pageNumber * this.searchCriteria.mobilePageSize);
      } else {
        this.selectedList = list.slice((this.searchCriteria.pageNumber - 1) * this.searchCriteria.pageSize, this.searchCriteria.pageNumber * this.searchCriteria.pageSize);
      }
    },
    async readMsg() {
      let list = this.selectedList
          .filter(a => a.selected)
          .map(a => ({
            id: a.id ? a.id.toString() : "",
            category: a.category || ""
          }));
      if (list && list.length > 0) {
        let obj = {
          msgId: JSON.stringify(list)
        };
        await this.$store.dispatch(`${INBOX_READ_BULK_MSG}`, { obj });
        this.getInboxMsg();
      } else {
        this.$parent.openAlert(false,locale.getMessage(`message.readMsgError`));
      }
    },
    claimBonus(bonusType = 0, bonusId = 0) {
      if(bonusType === InboxMsgBonus.VOUCHER) {
        this.claimVoucherDialogShow = true
        this.bonusId = bonusId
      } else if(bonusType === InboxMsgBonus.BONUS) {
        this.closeMsgDialogs();
        this.closeMsgDialog();
        this.$router.push({
          name: ROUTE_NAME.DEPOSIT,
          params: {
            bonusId: bonusId,
            lang: this.$route.params.lang
          }
        })
      }
    },
    async showVoucherClaim(bonusType = 0, bonusId = 0) {
      if (bonusType > 0) {
        this.claimVoucherButtonShow = bonusType !== InboxMsgBonus.VOUCHER;

        if (bonusType === InboxMsgBonus.VOUCHER) {
          const filter = { id: bonusId };
          await this.$store.dispatch(`${IS_VOUCHER_CLAIMED}`, { filter })
              .then(() => {
                this.$store.dispatch(`${IS_VOUCHER_CLAIMED_RESET}`)
              });
        } else if (bonusType === InboxMsgBonus.BONUS) {
          const filter = { id: bonusId };
          await this.$store.dispatch(`${IS_BONUS_CLAIMED}`, { filter })
              .then(() => {
                this.$store.dispatch(`${IS_BONUS_CLAIMED_RESET}`)
              });
        }
      } else {
        this.claimVoucherButtonShow = false;
      }
    },
    closeClaimVoucherDialog() {
      this.claimVoucherDialogShow = false
    },
    claimSuccessCloseDialog() {
      this.claimVoucherDialogShow = false
      this.closeMsgDialogs();
      this.closeMsgDialog();
      this.$parent.openAlert(true, locale.getMessage(`message.voucherBonusApplied`));
    }
  }
};
</script>
<style lang="scss">
.flow-overHeight {
  height: 450px;
  overflow: auto;
}

.desktop_inbox_card {
  border-radius: 12px !important;
  //height: 660px !important;
  min-height: 700px;
  font-family: 'Roboto', sans-serif;

  .inbox-desktop-txt {
    font-weight: bold;
  }
}

.inbox-card {
  overflow-x: hidden;
  overflow-y: hidden;

  .inbox-message-isread label {
    color: var(--v-title_color2-base) !important;
    font-weight: normal !important;
  }

  .bonus-message-subject {
    .v-label {
      display: block;
      font-size: 14px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .v-input--selection-controls__input {
      display: none;
    }
  }

  .inbox-message-date {
    font-size: 10px;
    align-self: center;
  }
}

.inbox-content {
  font-size: 14px !important;
  font-family: 'Roboto', sans-serif;
}

.inbox-tab {
  border-radius: 12px;
  width: 150px;
  margin-right: 16px;
  padding: 10px;
  background-color: #fff;
  text-transform: capitalize;
}

.font-weight {
  font-weight: bold;
}

.inbox-details-header {
  background-color: #f3f5f6;
  border-radius: 12px;
}

.inbox-sub {
  font-family: 'Roboto', sans-serif;
  color: #6c6c6c !important;
  text-transform: none !important;
  font-size: 14px;
}

.tab-btn {
  border-style: solid !important;
  border-color: #ffce01 !important;
}

.selected-tab {
  border-radius: 12px;
  width: 150px;
  margin-right: 16px;
  padding: 10px;
  background-color: #ffce01 !important;
  text-transform: capitalize;
}

.not-selected-tab {
  border-radius: 12px;
  width: 150px;
  margin-right: 16px;
  padding: 10px;
  color: #6c6c6c !important;
  border-color: #ffce01;
  background-color: #fff !important;
  text-transform: capitalize;
}

.inbox-tab-mobile {
  width: 120px;
  margin-right: 10px;
  padding: 5px;
  background-color: #fff;
  text-transform: capitalize;
}

.inbox_pagination .v-pagination {
  li {
    border: none !important;

    button {
      border: none !important;
      font-size: 14px;
    }
  }
}

.inbox_msg_content {
  font-family: 'Heebo-Medium';
  font-size: 14px;
  text-align: left;
  width: 100%;
  max-width: 100%;
  text-transform: none !important;
  overflow-x: hidden;

  .ql-align-center {
    text-align: center;
  }

  div, table {
    max-width: 100% !important;
  }

  table {
    width: 100% !important;
  }
}

.inbox_msg_content img {
  max-width: 100%;
  height: auto;
  display: block;
}

.vip_summary_pagination .v-pagination {
  li {
    border: none !important;

    button {
      border: none !important;
      font-size: 12px;
    }
  }
}

.claim-now-button-blue {
  width: 120px !important;
  height: 32px !important;
  background-color: #0080F6 !important;
  border-radius: 16px !important;
}

.claim-now-button-yellow {
  width: 120px !important;
  height: 32px !important;
  background-color: #FFCE01 !important;
  border-radius: 16px !important;
  color: #000000 !important;
}

.more-details-button {
  width: 120px !important;
  height: 32px !important;
  background-color: #0080F6 !important;
  border-radius: 16px !important;
}

@media (max-width: 959px) {
  .inbox-card {
    height: 80%;
    overflow-x: hidden;
    overflow-y: hidden;

    .inbox-message-isread label {
      color: var(--v-title_color2-base) !important;
    }
  }
}
</style>
